
export default {
    props: {
        to: {
            type: [String, Object],
            required: true
        },
        custom: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        computedTo() {
            let query = { ...this.$route.query };
            if (this.to.query) {
                query = { ...query, ...this.to.query };
            }
            if( !query.lang ){
                query.lang = "es_MX";
            }
            let basePath = '';
            if (typeof this.to === 'string') {
                return `${basePath}${this.to}`;
            } else if (typeof this.to === 'object' && this.to.path) {
                return {
                    ...this.to,
                    query,
                    path: `${basePath}${this.to.path}`
                };
            }
            return this.to;
        }
    }
};
